import RawTableOverview from "../../../../components/Partners/DataIntegrations/BrandConfigurationReport/BrandConfigurationOverview/RawTableOverview/RawTableOverview"

const RawTableOverviewScreen = () => {
  return (
    <>
    <RawTableOverview />
    </>
  )
}

export default RawTableOverviewScreen